import { render, staticRenderFns } from "./FF.vue?vue&type=template&id=10f1b2d2"
import script from "./FF.vue?vue&type=script&lang=js"
export * from "./FF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports